// Same check as the backend CNP validator (Volt2-API): 13 digits, the last
// one a control digit over the first twelve.
const CNP_WEIGHTS = '279146358279';

export const CNP_LENGTH = 13;

export function isCnpValid(cnp: string): boolean {
  if (!/^\d{13}$/.test(cnp)) {
    return false;
  }

  const sum = [...CNP_WEIGHTS].reduce(
    (total, weight, index) => total + Number(cnp[index]) * Number(weight),
    0
  );
  const rest = sum % 11;
  const control = rest > 9 ? 1 : rest;

  return Number(cnp[12]) === control;
}
